export class Locale {
  public static locale: string
}
